<h3>{{i18n "admin.wizard.category_settings.custom_wizard.title"}}</h3>
<section class="field new-topic-wizard">
  <label for="new-topic-wizard">
    {{i18n "admin.wizard.category_settings.custom_wizard.create_topic_wizard"}}
  </label>
  <div class="controls">
    <ComboBox
      @value={{this.wizardListVal}}
      @content={{this.wizardList}}
      @onChange={{this.changeWizard}}
      @options={{hash none="admin.wizard.select"}}
    />
  </div>
</section>